const routes = [
    {
        path: '/supplier/risk_management/dashboard',
        name: 'SupplierRiskManagementDashboard',
        component: () => import('../../views/supplier/risk_management/dashboard/Dashboard.vue')
    },
]

export default routes;